import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { withDataConverter } from '@beef/react';
import { getAccountType } from "../../../../../../../../../../utils/analytics";
import { getWindow } from "../../../../../../../../../../utils/window";
import { ymPushParams } from "../../../../../../../../../../utils/ym.alternative";
import { Input } from "../../../../../../../../../../components/Input";
import { getAnalyticsConverter } from "./analytics";
var analyticsConverter = getAnalyticsConverter({
  getAccountType: getAccountType,
  getWindow: getWindow,
  ymPushParams: ymPushParams
});
var _PhoneInput = function _PhoneInput(props) {
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    type: "tel",
    "data-t-id": "components-PhoneInput"
  }));
};

// @ts-expect-error withDataConverter without .d.ts
export var PhoneInput = withDataConverter(analyticsConverter)(_PhoneInput);